import React, { useState, useEffect,useRef } from "react";
import {Container, Row, Col,Form,Button, ButtonGroup,} from "react-bootstrap";
import { FaArrowRight } from 'react-icons/fa';
import grclogo from "../Images/GRC-Pulse-Logo.png";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import SnackbarContent from '@mui/material/SnackbarContent';
import Snackbar from '@mui/material/Snackbar';
import { Dialog,Typography,Box, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import * as yup from "yup";
import api from "../Services/api";
import CloseIcon from "@mui/icons-material/Close";
import AssessorAppBar from "../Component/Assessor/AssessorAppBar";
 import Forgot from "./Forgot";

 
 
const Login = ({setIsLoggedIn}) => {
  const [userType, setUserType] = useState("vendor");
  const [showPassword, setShowPassword] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false); 
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [showForgotPassword, setShowForgotPassword] = useState(false);
const [showOtpDialog, setShowOtpDialog] = useState(false);
const [timeLeft, setTimeLeft] = useState(300); // 5 min in seconds
  const [otpExpired, setOtpExpired] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);
const [clientUsername, setClientUsername] = useState("");

  let navigate = useNavigate();
 
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
 
  const handleUserTypeChange = (type) => {
    setUserType(type);
  
    
  };
  
 
  const clientvalidationSchema = yup.object({
    clientUsername: yup.string().required("Username is required"),
    clientPassword: yup.string().required("Password is required"),
  });
  const adminvalidationSchema = yup.object({
    adminPhone: yup.string().required("Username is required"),
    adminPassword: yup.string().required("Password is required"),
  });
  const vendorvalidationSchema = yup.object({
    vendorUsername: yup.string().required("Username is required"),
    vendorPassword: yup.string().required("Password is required"),
  })
  const assessorvalidationSchema = yup.object({
    assessorUsername: yup.string().required("Username is required"),
    assessorPassword: yup.string().required("Password is required"),
  })
  const corporatevalidationSchema = yup.object({
    CorporateUserId: yup.string().required("Username is required"),
    CorporatePassword: yup.string().required("Password is required"),
  })
 
  const initialValues = {
    clientUsername: "",
    clientPassword: "",
  };
  const initialVendorValues = {
    vendorUsername: "",
    vendorPassword: "",
  };
  const initialAdminValues = {
    adminPhone: "",
    adminPassword: "",
  };
 
const initialAssessorValues = {
  assessorUsername: "",
  assessorPassword: "",
}
const initialCorporateValues = {
  CorporateUserId: "",
  CorporatePassword: "",
}


useEffect(() => {
  formik.resetForm({
    values: userType === "client" ? initialValues :
           userType === "vendor" ? initialVendorValues :
           userType === "assessor" ? initialAssessorValues :  userType === "corporate" ? initialCorporateValues : initialAdminValues
  });
}, [userType]);


const formik = useFormik({
  key: userType,
  initialValues: userType === "client" ? initialValues : userType === "vendor" ? initialVendorValues : userType === "assessor"  ? initialAssessorValues  : userType === "corporate"  ? initialCorporateValues : initialAdminValues,
  validationSchema: userType === "client" ? clientvalidationSchema : userType === "vendor" ? vendorvalidationSchema : userType === "assessor" ? assessorvalidationSchema :  userType === "corporate" ? corporatevalidationSchema : adminvalidationSchema,
    onSubmit: async (values) => {
        // console.log("form values", values);
      try {
        let result;
        if (userType === "client") {
          result = await api.login.clientLogin({
            clientUsername: values.clientUsername,
            clientPassword: values.clientPassword,
          });
        }
        else if(userType === 'admin'){
          result = await api.login.adminLogin({
            adminPhone: values.adminPhone,
            adminPassword: values.adminPassword,
          });
        }
        else if(userType === 'assessor' ) {
          result = await api.login.assessorLogin({
            assessorUsername: values.assessorUsername,
            assessorPassword: values.assessorPassword,
 
          });
        }
        else if(userType === 'corporate' ) {
          result = await api.login.CorporateLogin({
            CorporateUserId: values.CorporateUserId,
            CorporatePassword: values.CorporatePassword,
 
          });
        }
      
        else {
          result = await api.login.vendorLogin({
            vendorUsername: values.vendorUsername,
            vendorPassword: values.vendorPassword,
          });
        // console.log("entered else", result);
        }
        // console.log("result", result?.data);
 
        let temp = result?.data?.filtterData;
        let temp1 = result?.data;
        
        let user ={
          id : temp?.id,
          Name: temp?.name,
          // companyName : temp?.name,
          companyId : temp?.companyId,
          // licenseMode : temp?.licenseMode,
          type : temp?.type
        }
        
        sessionStorage.setItem(  "user",  JSON.stringify(user)  );

        //  sessionStorage.setItem("Token",JSON.stringify(temp?.token))
         sessionStorage.setItem("Token",temp?.token);
 
        if (userType == 'client'){
         if(result.status === 400){
            setSnackbarMessage( result.message);
            setSnackbarType("error");
            setOpenSnackbar(true);
          }
          else if(result.status === 404){
            setSnackbarMessage( result.data.message);
            setSnackbarType("error");
            setOpenSnackbar(true);
          }
          else if(result.status === 401){
            setSnackbarMessage( result.data.message);
            setSnackbarType("error");
            setOpenSnackbar(true);
          
          }
          else if(result.status === 500){
            setSnackbarMessage( result.data.message);
            setSnackbarType("error");
            setOpenSnackbar(true);
          }
        else if(result.status === 200) {
            setSnackbarMessage(result.data.message);
            setSnackbarType("success");
            setOpenSnackbar(true);
            setClientUsername(formik.values.clientUsername)
               setShowOtpDialog(true);
               
  
         
          } 
          else{
            setSnackbarMessage("Some error occured please try again later");
          setSnackbarType('error');
          setOpenSnackbar(true);
          }
        }
        
       else if (userType == 'admin'){
          if(result.status === 400){
             setSnackbarMessage( result.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
           }
           else if(result.status === 404){
             setSnackbarMessage( result.data.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
           }
           else if(result.status === 401){
             setSnackbarMessage( result.data.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
           }
           else if(result.status === 500){
             setSnackbarMessage( result.data.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
           }
         else if(result.status === 200) {
             setSnackbarMessage(result.data.message);
             setSnackbarType("success");
             setOpenSnackbar(true);
             setTimeout(() => {
               navigate(`/${userType}dashboard`);
               setIsLoggedIn(true);
             }, 600);
           } 
           else{
             setSnackbarMessage("Some error occured please try again later");
           setSnackbarType('error');
           setOpenSnackbar(true);
           }
         }
         else if (userType == 'assessor'){
          if(result.status === 400){
             setSnackbarMessage( result.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
           }
           else if(result.status === 404){
             setSnackbarMessage( result.data.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
           }
           else if(result.status === 401){
             setSnackbarMessage( result.data.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
             
           }
           else if(result.status === 500){
             setSnackbarMessage( result.data.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
           }
         else if(result.status === 200) {
             setSnackbarMessage(result.data.message);
             setSnackbarType("success");
             setOpenSnackbar(true);
             setTimeout(() => {
               navigate(`/${userType}dashboard`);
               setIsLoggedIn(true);
             }, 600);
           } 
           else{
             setSnackbarMessage("Some error occured please try again later");
           setSnackbarType('error');
           setOpenSnackbar(true);
           }
         }
         else if (userType == 'vendor'){
          if(result.status === 400){
             setSnackbarMessage( result.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
           }
           else if(result.status === 404){
             setSnackbarMessage( result.data.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
           }
           else if(result.status === 403){
            setSnackbarMessage( result.data.message);
            setSnackbarType("error");
            setOpenSnackbar(true);
          }
           else if(result.status === 401){
             setSnackbarMessage( result.data.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
           }
           else if(result.status === 500){
             setSnackbarMessage( result.data.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
           }
         else if(result.status === 200) {
             setSnackbarMessage(result.data.message);
             setSnackbarType("success");
             setOpenSnackbar(true);
             setTimeout(() => {
               navigate(`/${userType}dashboard`);
               setIsLoggedIn(true);
             }, 600);
           } 
           else{
             setSnackbarMessage("Some error occured please try again later");
           setSnackbarType('error');
           setOpenSnackbar(true);
           }
         }
         else if (userType == 'corporate'){
          if(result.status === 400){
             setSnackbarMessage( result.data.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
           }
           else if(result.status === 404){
             setSnackbarMessage( result.data.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
           }
           else if(result.status === 403){
            setSnackbarMessage( result.data.message);
            setSnackbarType("error");
            setOpenSnackbar(true);
          }
           else if(result.status === 401){
             setSnackbarMessage( result.data.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
           }
           else if(result.status === 500){
             setSnackbarMessage( result.data.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
           }
         else if(result.status === 200) {
             setSnackbarMessage(result.data.message);
             setSnackbarType("success");
             setOpenSnackbar(true);
             setTimeout(() => {
               navigate(`/${userType}dashboard`);
               setIsLoggedIn(true);
             }, 600);
           } 
           else{
             setSnackbarMessage("Some error occured please try again later");
           setSnackbarType('error');
           setOpenSnackbar(true);
           }
         }
        else{
         
          setSnackbarMessage("Please select userType and try to login");
          setSnackbarType('error');
          setOpenSnackbar(true);
        }
      } catch (error) {
        console.error('Please fill in the correct credentials!!', error);
       

      }
    },
  });
    useEffect(() => {
    let timer;
    if (showOtpDialog && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      
      setOtpExpired(true);
    
    }
    return () => clearInterval(timer);
  }, [showOtpDialog, timeLeft]);


   const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

   const handleResendOtp = async () => {
    try {
      const response = await api.client.resendOTP({
        clientUsername: clientUsername,
      });
      if (response.status === 200) {
        setSnackbarMessage("OTP resent successfully. Check your email.");
        setSnackbarType("success");
        setOpenSnackbar(true);
        setOtpExpired(false);
        setTimeLeft(300); // restart 5 minutes
      } 
         else if(response.status === 404){
             setSnackbarMessage( response.data.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
           }
              else if(response.status === 400){
             setSnackbarMessage( response.data.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
           }
            else if(response.status === 410){

             setSnackbarMessage( response.data.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
              setTimeLeft(300);
           }
              else if(response.status === 500){
             setSnackbarMessage( response.data.message);
             setSnackbarType("error");
             setOpenSnackbar(true);
           }
      else {
        setSnackbarMessage("Failed to resend OTP. Try again.");
        setSnackbarType("error");
        setOpenSnackbar(true);
      }
    } catch (error) {
      setSnackbarMessage("Something went wrong while resending OTP.");
      setSnackbarType("error");
      setOpenSnackbar(true);
    }
  };
   const handleChange = (index, value) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Auto focus next
      if (value && index < otp.length - 1) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  // Combine OTP digits into one string
  const otpValue = otp.join("");


const handleCloseDialog = () => {

  setShowOtpDialog(false)
  setOtp(["", "", "", "", "", ""])
   setOtpExpired(false)
        setTimeLeft(300); 
}
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };
  const handleForgotPassword = (userType) => {
    
  
    if (!userType) {
      setSnackbarMessage("Please select userType to continue");
      setSnackbarType("error");
      setOpenSnackbar(true);
      return;
    }
   
  
    else{
    setShowForgotPassword(true);
    }
  };
  
  return (
    <>
<Container fluid style={{ height: "100vh", padding: 0 }}>
 
      <Row style={{ height: "100%", margin: 0 }}>
      <Col
  xs={12} md={5}
  style={{
    background: "linear-gradient(45deg, rgba(28,28,28,1) 68%, rgba(213,214,215,1) 48%)",
    display: 'flex',           
    flexDirection: 'column',
    justifyContent: 'center', 
    alignItems: 'center',    
    height: '100vh',           
  }}
>
 <a href="https://www.grcpulse.in/" target="_blank"><img width="250px" src={grclogo} alt="Logo" /></a> 
  <p className=" pt-2 text-center" style={{fontSize:'20px',color:'gray',letterSpacing:'0.5px'}}>ʏᴏᴜʀ ᴄᴏᴍᴘʟɪᴀɴᴄᴇ ᴘᴀʀᴛɴᴇʀ</p>
</Col>
 
     
        <Col
          xs={12} md={7}
          style={{
            backgroundColor: "#B22222",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button className=" text-center" style={{position:'absolute',top:'2%',right:'1%',color:'white'}}  onClick={() => handleUserTypeChange("admin")}  variant={userType === "admin" ? "dark" : "white"}  >
 {/* <img src={adminIcon} alt="adminIcon" height="40px" width="55px"></img> */}
<p className='text-center '>Admin</p>
 
</Button>
<Button className=" text-center" style={{position:'absolute',top:'2%',right:'7%',color:'white'}}  onClick={() => handleUserTypeChange("corporate")}  variant={userType === "corporate" ? "warning" : "transparent"}  >
 {/* <img src={adminIcon} alt="adminIcon" height="40px" width="55px"></img> */}
<p className='text-center '>Corporate</p>
 
</Button>
      
          <div
            style={{
              position: "absolute",
              top: "53%",
              left: "71%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "#ffff",
              padding: "30px",
              borderRadius: "2px",
          
              width: "100%",
              maxWidth: "400px",
            }}
          >
             {!showForgotPassword ? (
<div>
           <h4 className="text-center p-2 text-secondary">Login as</h4>
          <hr ></hr>
            <form onSubmit={formik.handleSubmit}>

            <ButtonGroup
          toggle
          className="m-3 d-flex"
         
        >
 
 {/* <div className="m-2" style={{borderLeft:'0.5px solid gray',height:'40px'}}></div> */}
<Button className='  text-center'  onClick={() => handleUserTypeChange("vendor")} variant={userType === "vendor" ? "danger" : "white"} >  
{/* <img  src={vendorIcon} alt="vendorIcon" height="40px" width="60px" ></img> */}
<p className='text-center '>Vendor</p>
 
</Button>
<Button className="text-center  "  onClick={() => handleUserTypeChange("client")} variant={userType === "client" ? "success" : "white"}>
 {/* <img src={clientIcon} alt="clientIcon" height="40px" width="40px"></img> */}
<p className='text-center '>Establishment</p>
 
</Button>

{/* <div className="m-2"style={{borderLeft:'0.5px solid gray',height:'40px'}}></div> */}
<Button className='  text-center' onClick={() => handleUserTypeChange("assessor")} variant={userType === "assessor"  ? "danger" : "white"} >  
{/* <img  src={assesorIcon} alt="assesorIcon" height="40px" width="60px" ></img> */}
 <p className='text-center '>Assessor</p>
 
</Button>
{/* <Button className=" text-center p-2"  onClick={() => handleUserTypeChange("admin")}  variant={userType === "admin" ? "warning" : "white"}  >
 <img src={adminIcon} alt="adminIcon" height="40px" width="55px"></img>
<p className='text-center '>Admin</p>
 
</Button> */}
</ButtonGroup>

              <div style={{ marginBottom: "20px" }}>
                <TextField
                className="mt-2"
                  label="Username"
                  variant="outlined"
                  fullWidth
                  name={userType === "client" ? "clientUsername" : userType === "admin" ? "adminPhone" : userType === "assessor" ? "assessorUsername" : userType ==="corporate"? "CorporateUserId": "vendorUsername"}
                  value={formik.values[userType === "client" ? "clientUsername" : userType === "admin" ? "adminPhone" : userType === "assessor" ? "assessorUsername" : userType ==="corporate"? "CorporateUserId" : "vendorUsername"]}
                  onChange={formik.handleChange}
                  InputLabelProps={{ shrink: true }} 
                  error={formik.touched[userType === "client" ? "clientUsername" : userType === "admin" ? "adminPhone" : userType === "assessor" ? "assessorUsername" : userType ==="corporate"? "CorporateUserId" : "vendorUsername"] && Boolean(formik.errors[userType === "client" ? "clientUsername" : userType === "admin" ? "adminPhone" : userType === "assessor" ? "assessorUsername" : userType ==="corporate"? "CorporateUserId" : "vendorUsername"])}
                  helperText={formik.touched[userType === "client" ? "clientUsername" : userType === "admin" ? "adminPhone" : userType === "assessor" ? "assessorUsername" : userType ==="corporate"? "CorporateUserId" : "vendorUsername"] && formik.errors[userType === "client" ? "clientUsername" : userType === "admin" ? "adminPhone" : userType === "assessor" ? "assessorUsername" : userType ==="corporate"? "CorporateUserId": "vendorUsername"]}
                />
              </div>
              <div style={{ marginBottom: "10px" }}>
                <FormControl fullWidth variant="outlined">
                  <TextField
                    type={showPassword ? "text" : "password"}
                    label="Password"
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{ shrink: true }} 
                    name={userType === "client" ? "clientPassword" : userType === "admin" ? "adminPassword" : userType === "assessor" ? "assessorPassword" : userType ==="corporate"? "CorporatePassword" : "vendorPassword"}
                    value={formik.values[userType === "client" ? "clientPassword" : userType === "admin" ? "adminPassword" : userType === "assessor" ? "assessorPassword" : userType ==="corporate"? "CorporatePassword":  "vendorPassword"]}
                    onChange={formik.handleChange}
                    error={formik.touched[userType === "client" ? "clientPassword" : userType === "admin" ? "adminPassword" : userType === "assessor" ? "assessorPassword" : userType ==="corporate"? "CorporatePassword" : "vendorPassword"] && Boolean(formik.errors[userType === "client" ? "clientPassword" : userType === "admin" ? "adminPassword" : userType === "assessor" ? "assessorPassword" : "vendorPassword"])}
                    helperText={formik.touched[userType === "client" ? "clientPassword" : userType === "admin" ? "adminPassword" : userType === "assessor" ? "assessorPassword" : userType ==="corporate"? "CorporatePassword" : "vendorPassword"] && formik.errors[userType === "client" ? "clientPassword" : userType === "admin" ? "adminPassword" : userType === "assessor" ? "assessorPassword" : "vendorPassword"]}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </FormControl>
              </div>
              { userType !== "admin" && (
              <button type="button" className="pb-3 text-secondary float-end d-flex" style={{fontSize:"12px"}} onClick={() => handleForgotPassword(userType)}>Forgot Password ?</button>
              )}
              <div className="form-check pb-2 text-center" >
                {/* <input type="checkbox"   className="form-check-input"  id="termsCheck"   onChange={(e) => formik.setFieldValue('terms', e.target.checked)}  /> */}
                  <label className="form-check-label" htmlFor="termsCheck" style={{fontSize:'12px'}}>
                  By logging in, you agreed to the{" "}
                       <a href="/terms-and-condition" target="_blank" rel="noopener noreferrer" style={{ color:"red",fontSize:'12px'}}>
                           Terms & Conditions <span style={{color:'black'}}>and</span> <a href="/PrivacyPolicy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                       </a>
                  </label>
              </div>
              <button type="submit" className="btn btn-dark" style={{ width: "100%" }} disabled={!(formik.isValid && formik.dirty)}>
                Login
              </button>
            </form>
            </div>

            ) : (
              <div>
                  <h4 className="text-center p-2 text-secondary">Forgot password ?</h4>
                  <hr ></hr>
  <Forgot 
    userType={userType}
   
    onClose={() => setShowForgotPassword(false)}
  
  />
    </div>
)}

          </div>
        </Col>
      </Row>
    </Container>
    <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx ={{
          marginRight:'5%',
          marginTop:'2%'
        }}
      >
        <SnackbarContent
          message={snackbarMessage}
          style={{
            backgroundColor: snackbarType === "success" ? "green" : "red",
            color: 'white',
            fontWeight: 'bold',
          }}
        />
      </Snackbar>
      <Dialog sx={{padding:'10px'}} open={showOtpDialog}>
          <IconButton
      aria-label="close"
      onClick={() => handleCloseDialog()}
      style={{
        position: "absolute",
        right: 0,
        top: 0,
        color:'red'
        
      }}
    >
      <CloseIcon />
    </IconButton>
  <Typography className="pb-1 pt-5 text-center">OTP Verification</Typography>
             <Typography className="text-center text-secondary" style={{fontSize:'15px'}} variant='secondary' >Check your registered mail for OTP</Typography>
   <Box display="flex" justifyContent="center" gap={1.5} m={3}>
        {otp.map((digit, index) => (
          <TextField
            key={index}
            inputRef={(el) => (inputRefs.current[index] = el)}
            value={digit}
            onChange={(e) => handleChange(index, e.target.value)}
            inputProps={{
              maxLength: 1,
              style: {
                textAlign: "center",
                borderRadius:'5px',
                width: "10px",
                height: "10px",
                border:'1px solid lightgray'
              },
            }}
          />
        ))}
      </Box>
  

          {otpExpired ? (
            <button
              
              className="btn text-danger"
              onClick={handleResendOtp}
            >
              Resend OTP
            </button>
          ) : (
 <div
            className="text-center pt-1"
            style={{ fontWeight: "normal", color: otpExpired ? "danger" : "gray" }}
          >
            OTP Expires in: {formatTime(timeLeft)}
          </div>
          )}
  
 
    <button
    className="btn m-3 btn-dark"
      onClick={async () => {
        try {
          const response = await api.client.verifyOTPEST({
            
            clientUsername: clientUsername ,
            otp : otpValue
          });
 let temp = response?.data?.filtterData;
        
        let user ={
          id : temp?.id,
          Name: temp?.name,
          // companyName : temp?.name,
          companyId : temp?.companyId,
          // licenseMode : temp?.licenseMode,
          type : temp?.type
        }
        
        sessionStorage.setItem(  "user",  JSON.stringify(user)  );

        //  sessionStorage.setItem("Token",JSON.stringify(temp?.token))
         sessionStorage.setItem("Token",temp?.token);
          if (response.status === 200) {
            setSnackbarMessage(response.data.message);
            setOpenSnackbar(true);
      setSnackbarType("success");

            setShowOtpDialog(false);

            // 🔹 Now navigate to dashboard
            setTimeout(() => {
              navigate(`/establishmentdashboard`);
              setIsLoggedIn(true);
            }, 500);
          }
          else if (response.status === 400){
            setSnackbarMessage(response.data.message);
      setSnackbarType("error");

            setOpenSnackbar(true);
          }
           else if (response.status === 410){
            setSnackbarMessage(response.data.message);
      setSnackbarType("error");
     

            setOpenSnackbar(true);
          }
          else if (response.status === 401){
            setSnackbarMessage(response.data.message);
      setSnackbarType("error");
 setOtp(["", "", "", "", "", ""])
            setOpenSnackbar(true);
          }
           else if (response.status === 500){
            setSnackbarMessage(response.data.message);
      setSnackbarType("error");

            setOpenSnackbar(true);
          }
           else {
            setSnackbarMessage(response.data.message);
      setSnackbarType("error");

            setOpenSnackbar(true);
          }
        } catch (error) {
     console.error('some error occured!')
        }
      }}
    >
      Verify
    </button>

</Dialog>
    </>
  );
};
 
export default Login;
 
